import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams, useLocation } from 'react-router-dom'
import { verifyCaseNumAndAccessCode} from "../actions/documents";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha, LoadCanvasTemplateNoReload } from 'react-simple-captcha';
import logo from '../images/logo.png'
import midGr from '../images/evrfy_new_middle_gr-01.svg'
import topGr from '../images/evrfy_top-01.svg'
import vrfy_gr_mobile from '../images/gr_mobile.png'
import vrfy_gr_desktop from '../images/gr_desktop.png'
import { Container, Row, Col, Button, Card, Form } from 'react-bootstrap'
//import { Document, Page } from 'react-pdf';
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import axios from "axios";
import PdfViewer from "./PdfViewer";
import Modal from 'react-bootstrap/Modal'
import LoadingSpinner from "./LoadingSpinner";



pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
 

const apiURL = `https://evrfy.ttlawcourts.org`;
//const apiURL = `http://localhost:4001`;




//Function to create Alerts +++++++++++++++++++++++++++++++++++++++++
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

//Styles Override +++++++++++++++++++++++++++++++++++++++++
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

//Query String parameters from URL +++++++++++++++++++++++++++++++++++++++++
function useQuery() {
  return new URLSearchParams(useLocation().search);
}




//BEGIN HERE +++++++++++++++++++++++++++++++++++++++++
const VerifyDocument = () =>{
  const classes = useStyles();
  const [DocumentError, setDocError] = React.useState(false);
  const [ExpiredError, setExpiredError] = React.useState(false);
  const [CaptchaError, setCaptchaError] = React.useState(false);
  const [AcCnError, setAcCnError] = React.useState(false);
  const [AllEmpty, setAllEmpty] = React.useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [pdfDoc, setPdfDoc] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };
  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };
  function handlePdfShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
  }
  //Display Error through Snackbar
  const DisplayDocError = () => {
    setDocError(true);
  };

  const DisplayExpiredError = () => {
    setExpiredError(true);
  };

  const DisplayCpatchaError = () => {
    setCaptchaError(true);
  };

  const DisplayAllEmpty = () => {
    setAllEmpty(true);
  };

  const DisplayAcCnError = () => {
    setAcCnError(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setDocError(false);
    setCaptchaError(false);
    setAcCnError(false);
    setAllEmpty(false);
  };
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  let query = useQuery();
  let ac_from_url = query.get("ac");
  let cn_from_url = query.get("cn");
  //console.log(ac_from_url)
  const [ac_value, setAcValue] = useState(ac_from_url?ac_from_url:"");
  const [cn_value, setCnValue] = useState(cn_from_url?cn_from_url:"");
  const [captcha_value, setCaptchaValue] = useState('');
  const [user_captcha_input, setUserCaptchaValue] = useState('');
  const onChangeAccessCode = (e) => {
    setAcValue(e.target.value);
    //console.log(ac_value);
  }
  const onChangeCaseNumber = (e) => {
    setCnValue(e.target.value);
  }
  const onChangeCaptchaValue = (e) => {
    //console.log(e.target.value);
    setUserCaptchaValue(e.target.value);
    //console.log(user_captcha_value);
  }
  useEffect(() => {
    // Similar to componentDidMount
    loadCaptchaEnginge(6,'white','#222','lower');
  },
  [captcha_value]); // Only re-run the effect if captcha_value changes
  //clear the form
  const refreshData = () => {
    //setAcValue("");
    //setCnValue("");    
  }

  //Attempt to find Document
  //--------------------------------------------------------------------------
    const VerifyDoc = () => {
      //console.log(pdfDoc);
      
      //First check to see if input values exist and are correct---------------
      let tmp_usr_captcha = document.getElementById('user_captcha_input').value;
      let user_captcha_value = tmp_usr_captcha.toLowerCase();
      if (ac_value ==="" || cn_value ==="" || tmp_usr_captcha ==="" ) 
      {
        DisplayAllEmpty();
        return;
      }
      if (validateCaptcha(user_captcha_value, true)===false) {
        DisplayCpatchaError();
        return;
      }
      if (ac_value === "" && cn_value === "") 
      {
        DisplayAcCnError();
        return;
      }
      setIsLoading(true);
      //clear the input fields ---------------
      //refreshData();
      //--------------------------------------

      //1. >>> first test to see if file exist in database
      var docCheckUrl = `${apiURL}/api/documents/${ac_value}/${cn_value}`;
      axios.get(docCheckUrl)
      .then(result =>{
        //2. >>> if file exists attempt to downlaod
        if(result.data.status !== 0)
        {
          if(result.data.status === "5001"){   //expired document
            DisplayExpiredError();
            setIsLoading(false)   // Hide loading screen 
            return;
          }
          else{
            var pdfFileURL = `${apiURL}/api/documents/${ac_value}/${cn_value}`;
            setPdfDoc(pdfFileURL);
            fetch({pdfFileURL}, {
              method: 'GET',
              responseType: 'application/pdf' //Force to receive data in a Blob Format
            })
            .then(response => {
              //3. >>> open PDF file in new window
              //window.open(pdfFileURL);
              handlePdfShow(true);
              setIsLoading(false)   // Hide loading screen 
            })
            .catch(error => {
                //console.log(error);
                DisplayDocError();
                setIsLoading(false)   // Hide loading screen 
            });
          }
        }
        else{
          DisplayDocError()
          setIsLoading(false)   // Hide loading screen 
        }
      })
      .catch(error => {
        DisplayDocError();
        //console.log(error);
        setIsLoading(false)   // Hide loading screen 
      });

        
                
    }
  
    
    return (

      <div>

        <div>
        <Modal className="modal-container" 
          onContextMenu={(e) => e.preventDefault()}
          show={show} fullscreen={fullscreen} 
          onHide={() => setShow(false)}
        >
          <Modal.Header className="modal-container"  closeButton>
          </Modal.Header>
          <Modal.Body className="modal-container" >
            <div>
              <div className="controls">
                  <div className="ctl-btn-prev">
                    <button onClick={prevPage} disabled={pageNumber === 1}>
                    &#60;
                    </button>
                  </div>
                
                  <div className="ctl-btn-next">
                      <button onClick={nextPage} disabled={pageNumber === numPages}>
                      &#62;
                        </button>
                  </div>
              </div>

              <Document
                file={pdfDoc}
                onLoadSuccess={onDocumentLoadSuccess}
                onContextMenu={(e) => e.preventDefault()}
                className="pdf-container"
              >
                <Page pageNumber={pageNumber} />
              </Document>
            </div>
          </Modal.Body>
        </Modal>
        
        </div>





      <div className="vrfy-section container get-doc">




      <div className="container-fluid vrfy-bg">


        <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-8 vrfy-instructions">
          <img src={topGr}/>
          {/*

          <h2 className="vrfy-header">Quickly Verify Court Documents</h2>

              <div className="container">
                <div className="row">
                  <div className="ev-option-a ev-options col-5">
                      <div className="ev-lg-txt ev-a">
                      <span className="s-item ev-li">A</span> 
                      <p className="ev-options-txt ev-ln"><strong  className="s-a">Scan the QR Code </strong><br/>
                      on the court document <br/>
                      </p>
                      <p className="ev-sm-txt">using your mobile device camera or computer equipped with QR Code reader</p>
                      </div>
                  </div>

                  <div className="ev-option-b ev-options-m col-1"><p>or</p></div>

                  <div className="ev-options ev-option-b col-6">
                    <div className="ev-lg-txt ev-a">
                      <span className="s-item ev-li">B</span> 
                      <p className="ev-options-txt"><span className="ev-ln">Using your web browser<br/> <strong>Visit</strong></span><br/><span>https://<strong  className="s-a">evrfy.ttlawcourts.org</strong></span></p>
                    </div>
                  </div>

                </div>

              </div>


              <div className="ev-md-txt ev-b">
                <span className="vrfy-arrow-ln"></span>
                <span className="ev-ln ev-item">Make sure the "<strong>Access Code</strong>" and "<strong>E-vrfy Number</strong>" <br/>are entered correctly.</span>
              </div>
              <div className="ev-md-txt ev-b">
                <span className="vrfy-arrow-ln"></span>
                <span className="ev-ln ev-item">Enter the Captcha code displayed and click the "<strong>View</strong>" button.</span>
              </div>

              */}















            {/*
            <div className="ev-lg-txt ev-a">
            <span className="s-item ev-li">A</span> 
            <p className="ev-ln"><strong  className="s-a">Scan the QR Code </strong>
            on the court document <br/>
            <span className="ev-sm-txt">using your mobile device camera or computer equipped with QR Code reader</span></p>
            </div>
            <div className="ev-a">
              <span className="ev-or">or</span>
            </div>
            <div className="ev-lg-txt ev-a">
              <span className="s-item ev-li">B</span> <span className="ev-ln">visit https://<strong  className="s-a">evrfy.ttlawcourts.org</strong></span>

            </div>
              <div className="ev-divider"></div>
            <div className="ev-md-txt ev-b">
              <span className="vrfy-arrow-ln"></span>
              <span className="ev-ln">Ensure that the "<strong>Access Code</strong>" and "<strong>E-vrfy Number</strong>" <br/>are entered correctly</span>
            </div>
            <div className="ev-md-txt ev-b">
            <span className="vrfy-arrow-ln"></span>
            <span className="ev-ln">Enter the Captcha code displayed and click the "<strong>View</strong>" button</span>
            </div>
            */}

            {/*
            <div className="vrfy-steps">

              <div><span className="ev-option-a">Option 1</span><span className="ev-option-b">Scan QR Code on Court Document</span></div>
              <ul>
                <li><strong>STEP <span className="s-item">1</span></strong> Scan the QR code on the document or visit </li>
                <li><strong>STEP <span className="s-item">2</span></strong> Enter Access Code and E-vrfy Number</li>
                <li><strong>STEP <span className="s-item">3</span></strong> Click the "View" button</li>
              </ul>

              <div><span class="ev-option-a">Option 2</span><span className="ev-option-b">Directly visiting evrfy.ttlawcourts.org</span></div>
              <ul>
                <li><strong>STEP <span className="s-item">1</span></strong> Scan the QR code on the document or visit </li>
                <li><strong>STEP <span className="s-item">2</span></strong> Enter Access Code and E-vrfy Number</li>
                <li><strong>STEP <span className="s-item">3</span></strong> Click the "View" button</li>
              </ul>

            </div>
              */}
            

          


        </div>

          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 vrfy-form-wrapper">
          <div className="submit-form">

            <Snackbar open={DocumentError} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                Document not found
              </Alert>
            </Snackbar>

            <Snackbar open={ExpiredError} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="warning">
                Document has expired.
              </Alert>
            </Snackbar>

            <Snackbar open={CaptchaError} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                Incorrect Captcha value.
              </Alert>
            </Snackbar>

            <Snackbar open={AcCnError} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                Incorrect Access Code and/or E-vrfy Number.
              </Alert>
            </Snackbar>

            <Snackbar open={AllEmpty} autoHideDuration={3000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                All fields are required.
              </Alert>
            </Snackbar>

            

            {isLoading ? (<LoadingSpinner />) :
            (
              <div></div>
            )
            }


            {false ? (
              <div></div>
            ) : (


           
              //VERIFY DOCUMENT FORM
              //+++++++++++++++++++++++++++++++++
              //+++++++++++++++++++++++++++++++++
              <div className="vrfy-document-form">
                  <div className="form-group">
                    <label htmlFor="access_code">Enter <b>Access Code</b> from court document</label>
                    <input
                      type="text"
                      textalign={'center'}
                      className="form-control"
                      id="access_code"
                      required
                      autoComplete="off"
                      value={ac_from_url ? ac_from_url : ac_value} 
                      //value="83n3xql0x"
                      onChange={onChangeAccessCode}
                      name="access_code"
                    />
                  </div>
            

                  <div className="form-group">
                    <label htmlFor="case_number">Enter <b>E-vrfy Number</b> from court document</label>
                    <input
                      type="text"
                      className="form-control"
                      id="case_number"
                      autoComplete="off"
                      required
                      value={cn_value}
                      //value="test345689098"
                      onChange={onChangeCaseNumber}
                      name="case_number"
                    />
                  </div>

                  <div><LoadCanvasTemplateNoReload className="captcha-canvas" /></div>
                  
                  <div  className="form-group vrfy-captcha">
                  <label htmlFor="case_number"> Enter Captcha Code you see above</label>
                    <input
                      type="text"
                      className="form-control captcha-value"
                      id="user_captcha_input"
                      autoComplete="off"
                      required
                      value = {user_captcha_input}
                      onChange={onChangeCaptchaValue}
                      name="user_captcha_input"
                    />
                    <div className="lc">lowercase characters only</div>
                  </div>
                  
                  <div className="submit-row">
                    <button onClick={VerifyDoc} disabled={isLoading} className="btn btn-success">
                      <strong>VIEW</strong>
                    </button>
                  </div>
              </div>
            )}

          </div>
          </div>
          
          <div className="vrfy-dis">
          This E-vrfy System verifies documents issued by the Judiciary of Trinidad and Tobago. Only persons who have been shown documents bearing an Access Code and E-vrfy Number are permitted to use this system. Unauthorised use of this authentication and verification system is forbidden. For security purposes, IP addresses are logged in the system.
            </div>
        </div>
      </div>
      </div>


      
      {/* SECTION - HOW TO */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      <div className="vrfy-section container-fluid">

        <div className="row how-to">
            <div className="col-xs-12" order={2}>

              <h2 className="vrfy-header">How to <strong className="s-l">verify</strong> a court document</h2>
              
              <div className="container how-to-wrap">
                <div className="row">
                  <div className="col-sm">
                    

                    <h4>By visiting <strong className="s-l">evrfy.ttlawcourts.org</strong>  <strong className="s-l"></strong></h4>
                    <div className="img-desktop"><img src={vrfy_gr_desktop} /></div>
                    <div className="steps-desktop steps">
                        <ol>
                          <li>
                            <h5><strong>Enter URL below in your browser</strong></h5>
                            <p className="steps-sub">https://evrfy.ttlawcourts.org <span className="st">B</span></p>
                          </li>

                          <li>
                            <h5>Make sure the following information is entered correctly:</h5>
                            <ul>
                              <li className="vrfy-arrow">Access Code <span className="st">C</span></li>
                              <li className="vrfy-arrow">E-vrfy Number <span className="st">D</span></li>
                              <li className="vrfy-arrow">CAPTCHA Code</li>
                            </ul>
                          </li>


                          <li>
                          <p className="steps-sub"></p>

                          <h5>Click <strong>"View"</strong></h5>
                          </li>

                        </ol>
                    </div>

                  </div>

                  <div className="col-sm middle-column" order={0}>
                    <img className="m-gr" src={midGr} />
                  </div>

                  <div className="col-sm" order={2}>
                  <h4>By scanning <strong className="s-l">QR Code </strong> <strong className="s-l"></strong></h4>
                    <div className="img-desktop"><img src={vrfy_gr_mobile} /></div>
                    <div className="steps-desktop steps">
                        <ol>
                          <li>
                            <h5><strong>Scan the QR Code <br/>on the court document <span className="st">A</span></strong></h5>
                            <p className="steps-sub">with the camera on your mobile device, tablet or with a computer equipped with a QR Code reader.</p>
                            {/*<p className="steps-sub">the "Access Code" will be automatically entered</p> */}

                          </li>

                          <li>
                            <h5>Make sure the following information is entered correctly:</h5>
                            <ul>
                            <li className="vrfy-arrow">Access Code <span className="st">C</span></li>
                            <li className="vrfy-arrow">E-vrfy Number <span className="st">D</span></li>
                              <li className="vrfy-arrow">CAPTCHA Code</li>
                            </ul>
                          </li>
                          <p className="steps-sub"></p>

                          <li>
                            <h5>Click <strong>"View"</strong></h5>
                          </li>

                        </ol>
                    </div>
                  </div>

                </div>
              </div>
              
            </div>

        </div>

      </div>
    </div>
      
    );


};

export default VerifyDocument;

